'use client'

import React, { useState, useCallback } from 'react'
import styles from './Posts.module.css'

interface ReplyFormProps {
  onSubmit: (content: string) => Promise<void>
}

export const ReplyForm = React.memo(({ onSubmit }: ReplyFormProps) => {
  const [content, setContent] = useState('')
  const [isSubmitting, setIsSubmitting] = useState(false)

  // Handle form submission
  const handleSubmit = useCallback(async (e: React.FormEvent) => {
    e.preventDefault()
    if (!content.trim() || isSubmitting) return

    setIsSubmitting(true)
    try {
      await onSubmit(content.trim())
      setContent('') // Clear form after successful submission
    } catch (error) {
      console.error('Error submitting reply:', error)
    } finally {
      setIsSubmitting(false)
    }
  }, [content, isSubmitting, onSubmit])

  // Handle textarea content change
  const handleContentChange = useCallback((e: React.ChangeEvent<HTMLTextAreaElement>) => {
    setContent(e.target.value)
  }, [])

  return (
    <form onSubmit={handleSubmit} className={styles.replyForm}>
      <div className={styles.formGroup}>
        <textarea
          value={content}
          onChange={handleContentChange}
          placeholder="Write a reply..."
          rows={2}
          maxLength={280}
          className={styles.replyTextarea}
          disabled={isSubmitting}
        />
        <div className={styles.charCount}>
          {content.length}/280
        </div>
      </div>
      <button 
        type="submit" 
        disabled={!content.trim() || isSubmitting}
        className={styles.replyButton}
      >
        {isSubmitting ? 'Replying...' : 'Reply'}
      </button>
    </form>
  )
}) 